/**
 * Dynamic Configuration Service
 * Automatically resolves the backend address based on the current environment.
 */

const HOSTNAME = window.location.hostname;
const PROTOCOL = window.location.protocol;

// Use 'wss:' if the site is running on https, otherwise 'ws:'
const WS_PROTOCOL = PROTOCOL === "https:" ? "wss:" : "ws:";

// Check if we are running in development
// ONLY localhost or 127.0.0.1 uses port 8000. 
// Public IPs or Domains use Nginx (port 80/443).
const isDevelopment =
    HOSTNAME === "localhost" ||
    HOSTNAME === "127.0.0.1";

// Backend Ports:
const BACKEND_PORT = isDevelopment ? ":8001" : "";
const SOCKET_IO_PORT = isDevelopment ? ":5001" : "";

// Base URLs
export const API_BASE_URL = `${PROTOCOL}//${HOSTNAME}${BACKEND_PORT}/api/`;

/** 
 * WS_BASE_URL:
 * Nginx will route /ws/ to the Daphne server on 8001
 */
export const WS_BASE_URL = `${WS_PROTOCOL}//${HOSTNAME}${BACKEND_PORT}/ws/chat/`;
export const WS_NOTIF_URL = `${WS_PROTOCOL}//${HOSTNAME}${BACKEND_PORT}/ws/notifications/`;

// If you are using a separate Socket.io server (Node.js) on port 5000
export const SOCKET_IO_URL = `${PROTOCOL}//${HOSTNAME}${SOCKET_IO_PORT}`;

const config = {
    API_BASE_URL,
    WS_BASE_URL,
    SOCKET_IO_URL,
};

export default config;
